import React, { useState } from "react";
import RankReport from "./RankReport";
import { scoreUserInput } from "./scoring";
import ExportableScorecard from "./ExportableScorecard";

const quizQuestions = [
  { id: "gender", question: "What’s your gender?", type: "multiple", options: ["Male", "Female", "Other"] },
  { id: "age", question: "How old are you?", type: "number", unit: "years" },
  { id: "height", question: "How tall are you?", type: "number", unit: "inches" },
  { id: "income", question: "What’s your annual income?", type: "number", unit: "USD" },
  { id: "education", question: "What’s your highest level of education?", type: "multiple", options: ["High school", "Some college", "Bachelor's", "Master's", "Doctorate"] }
];

function App() {
  const [started, setStarted] = useState(false);
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState({});

  const current = quizQuestions[step];

  const handleChange = (value) => {
    setAnswers({ ...answers, [current.id]: value });
  };

  const next = () => setStep((prev) => Math.min(prev + 1, quizQuestions.length - 1));
  const prev = () => setStep((prev) => Math.max(prev - 1, 0));

  return (
    <div style={{ maxWidth: 500, margin: "50px auto", padding: 20 }}>
      {!started ? (
        <div style={{ textAlign: "center" }}>
          <h1>Welcome to Ranked</h1>
          <p>Compare yourself to the dating marketplace.</p>
          <button onClick={() => setStarted(true)} style={{ padding: "10px 20px", fontSize: "16px" }}>
            Start Quiz
          </button>
        </div>
      ) : (
        <div style={{ border: "1px solid #ccc", borderRadius: 10, padding: 20 }}>
          <h2>{current.question}</h2>

          {current.type === "number" && (
            <input
              type="number"
              value={answers[current.id] || ""}
              onChange={(e) => handleChange(e.target.value)}
              placeholder={current.unit || ""}
              style={{ width: "100%", padding: 10, marginBottom: 20 }}
            />
          )}

          {current.type === "multiple" &&
            current.options.map((opt) => (
              <div key={opt}>
                <label>
                  <input
                    type="radio"
                    name={current.id}
                    value={opt}
                    checked={answers[current.id] === opt}
                    onChange={() => handleChange(opt)}
                  />{" "}
                  {opt}
                </label>
              </div>
            ))}

          <div style={{ marginTop: 30 }}>
            {step > 0 && <button onClick={prev} style={{ marginRight: 10 }}>Back</button>}
            {step < quizQuestions.length - 1 ? (
              <button onClick={next}>Next</button>
            ) : (
              <ExportableScorecard>
                <RankReport scores={scoreUserInput(answers)} />
              </ExportableScorecard>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default App;
